import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { filter, map } from 'rxjs/operators';
import { AuthFacade } from '@lyceo/shared/auth/data-access';
import { toObservable } from '@angular/core/rxjs-interop';

export function authGuard(): CanActivateFn {
  return () => {
    const authFacade: AuthFacade = inject(AuthFacade);
    const router: Router = inject(Router);

    return toObservable(authFacade.isDoneLoading).pipe(
      filter((isDone) => isDone),
      filter(() => !authFacade.hasLoginError()),
      map(() => {
        if (authFacade.isAuthenticated()) {
          return true;
        }

        return router.createUrlTree(['/login']);
      }),
    );
  };
}
